import { Link } from 'react-router';
import sc from 'web/components/styled';
import linkUnstyled from './linkUnstyled.css';

const LinkUnstyled = sc(Link)(linkUnstyled);
LinkUnstyled.displayName = 'LinkUnstyled';

export default LinkUnstyled;
